<script lang="ts" setup>
const model = defineModel<string>({ default: "" });

withDefaults(
  defineProps<{
    flat?: boolean;
    hideBubble?: boolean;
  }>(),
  {
    flat: true,
    hideBubble: true,
  },
);
</script>

<template>
  <VuetifyTiptap v-model="model" :flat="flat" :hide-bubble="hideBubble" v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps ?? {}" />
    </template>
  </VuetifyTiptap>
</template>
